import React, { useEffect, useState } from "react";
import {useTranslation} from "react-i18next";
import {dashboardAPI} from "../services/api";

const Navdata = () => {
    const {t} = useTranslation();

    const [isScenarioManagement, setIsScenarioManagement] = useState(false);

    const [isRuleManagement, setIsRuleManagement] = useState(false);

    const [isReports, setIsReports] = useState(false);
    const [canManageUsers, setCanManageUsers] = useState(false);

    const [iscurrentState, setIscurrentState] = useState('Dashboard');

    function updateIconSidebar(e: any) {
        if (e && e.target && e.target.getAttribute("sub-items")) {
            const ul: any = document.getElementById("two-column-menu");
            const iconItems: any = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                let id: any = item.getAttribute("sub-items");
                let menusId = document.getElementById(id);
                if (menusId){
                    (menusId.parentElement as HTMLElement).classList.remove("show");
                }
            });
            e.target.classList.add("active");
        }
    }
    useEffect(() => {
        document.body.classList.remove('twocolumn-panel');

        if(iscurrentState !== 'Scenario Management'){
            setIsScenarioManagement(false);
        }
        if(iscurrentState !== 'Rule Management'){
            setIsRuleManagement(false);
        }
        if(iscurrentState !== "Report Management"){
            setIsReports(false);
        }

    }, [
        iscurrentState,
        isRuleManagement,
        isScenarioManagement,
        isReports,
    ]);

    // Fetch current user to check permissions
    useEffect(() => {
        const fetchUser = async () => {
            try {
                const user: any = await dashboardAPI.getCurrentUser();
                const userData = user?.data || user;
                
                // Check if user can manage users (General Admin or Company Admin)
                const roles = userData?.roles || [];
                const canManage = roles.includes('ROLE_GENERAL_ADMIN') || roles.includes('ROLE_COMPANY_ADMIN');
                setCanManageUsers(canManage);
            } catch (error) {
                console.error('Failed to fetch current user for menu permissions:', error);
                // For demo users, allow access
                setCanManageUsers(true);
            }
        };
        fetchUser();
    }, []);

    const menuItems: any = [
        {
            id: "dashboard",
            label: t("Menu.dashboard"),
            icon: "las la-home",
            link: "/dashboard",
        },
        {
          id: "Alerts",
          label: t("Menu.alerts"),
          icon: "las la-bell",
          link: "/alerts",
        },
        {
            id: "scenarioManagement",
            label: t("Menu.scenarios"),
            icon: "las la-sitemap",
            link: "/scenarios",
        },

        {
          id: "Rules",
          label: t("Menu.rules"),
          icon: "las la-file-prescription",
          link: "/rules",
        },
        {
            id: "Transactions",
            label: t("Menu.transactions"),
            icon: "las la-file-invoice",
            link: "/transactions",
        },
        {
            id: "Reports",
            label: t("Menu.reports"),
            icon: "las la-poll",
            link: "/",
            click: function (e: any) {
                e.preventDefault();
                setIsReports(!isReports);
                setIscurrentState('Report Management');
                updateIconSidebar(e);
            },
            stateVariables: isReports,
            subItems: [
                {
                    id: "sales-reports",
                    label: t("Menu.sales_reports"),
                    link: "/sale-report",
                    parentId: "reports"
                },
                {
                    id: "scenario-add",
                    label: t("Menu.alert_reports"),
                    link: "/alert-reports",
                    parentId: "reports"
                },
            ],
        },
        {
            id: "Stores",
            label: t("Menu.stores"),
            icon: "las la-store",
            link: "/stores",
        },
        ...(canManageUsers ? [{
            id: "StoreGroups",
            label: t("Menu.store_groups"),
            icon: "las la-layer-group",
            link: "/store-groups",
        }] : []),
        ...(canManageUsers ? [{
            id: "Users",
            label: t("Menu.users"),
            icon: "las la-users",
            link: "/users",
        }] : []),
        {
            id: "Activity Logs",
            label: t("Menu.activity_logs"),
            icon: "las la-pen",
            link: "/activity-logs",
        },
    ];
    return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;
